/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import {
  useAuth, SignInButton, SignOutButton, UserButton
} from '@clerk/clerk-react';
import {
  Box, Button, Typography, AppBar, Toolbar,
  IconButton, Drawer, List, ListItem, ListItemText,
  Link, Container, TextField
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Routes, Route, useNavigate, useMatch } from 'react-router-dom';
import Hello from './components/Hello';

// fetch & display JWT
function JwtToken() {
  const { getToken } = useAuth();
  const [jwt, setJwt] = useState('');
  useEffect(() => {
    getToken().then(t => setJwt(t || ''));
  }, [getToken]);
  return (
    <Box mt={2}>
      <Typography>Your JWT: {jwt}</Typography>
    </Box>
  );
}

// splash when signed out
function SignedOutSplash() {
  return (
    <Box
      display="flex" flexDirection="column"
      justifyContent="center" alignItems="center"
      minHeight="100vh" textAlign="center"
    >
      <Typography variant="h3" component="h1" gutterBottom>
        Clockwork GM
      </Typography>
      <Box component="img" src={`${process.env.PUBLIC_URL}/splash.png`} alt="Splash"
           sx={{ maxWidth: 500, mb: 4 }} />
      <SignInButton mode="modal">
        <Button variant="contained" size="large">Sign In</Button>
      </SignInButton>
      <Box component="footer" mt={4}>
        <Typography variant="caption">
          © {new Date().getFullYear()} My Company.{' '}
          <Link href="/privacy" target="_blank">Privacy</Link> |{' '}
          <Link href="/tos" target="_blank">Terms of Service</Link>
        </Typography>
      </Box>
    </Box>
  );
}

// list of sessions + create button
function MainView() {
  const navigate = useNavigate();
  const sessions = ['Alpha', 'Beta', 'Gamma', 'Delta'];
  return (
    <Container sx={{ flexGrow: 1, py: 4 }}>
      <List>
        {sessions.map(s => (
          <ListItem button key={s} onClick={() => navigate(`/sessions/${s}`)}>
            <ListItemText primary={s} />
          </ListItem>
        ))}
        <ListItem button onClick={() => alert('Create Session')}>
          <ListItemText primary="Create Session" />
        </ListItem>
      </List>
    </Container>
  );
}

// chat view for one session
function SessionView() {
  const messages = [
    'Lorem ipsum dolor sit amet.',
    'Consectetur adipiscing elit.',
    'Sed do eiusmod tempor.',
    'Incididunt ut labore et dolore.'
  ];
  return (
    <Box display="flex" flexDirection="column" flexGrow={1}>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
        {messages.map((m, i) => (
          <Box
            key={i}
            display="flex"
            justifyContent={i % 2 ? 'flex-end' : 'flex-start'}
            mb={1}
          >
            <Box sx={{ bgcolor: '#eee', p:1, borderRadius:1 }}>
              {m}
            </Box>
          </Box>
        ))}
      </Box>
      <Box component="form" sx={{ display:'flex', p:1 }}>
        <TextField fullWidth placeholder="Type a message" />
        <Button variant="contained" sx={{ ml:1 }}>Send</Button>
      </Box>
    </Box>
  );
}

// layout when signed in
function SignedInLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggle = () => setDrawerOpen(o => !o);
  const navigate = useNavigate();
  const isSession = !!useMatch('/sessions/:id');

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <AppBar position="static" color={isSession ? 'default' : 'primary'}>
        <Toolbar>
          {isSession && (
            <IconButton onClick={() => navigate('/sessions')}>
              <ArrowBackIcon />
            </IconButton>
          )}
          <Box flexGrow={1} />
          <UserButton />
          <IconButton color="inherit" onClick={toggle}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={toggle}>
        <List>
          {isSession && (
            <ListItem button onClick={() => alert('Invite User')}>
              <ListItemText primary="Invite User" />
            </ListItem>
          )}
          <SignOutButton>
            <ListItem button>
              <ListItemText primary="Sign Out" />
            </ListItem>
          </SignOutButton>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Routes>
          <Route path="/sessions" element={<MainView />} />
          <Route path="/sessions/:id" element={<SessionView />} />
          <Route path="*" element={<MainView />} />
        </Routes>
      </Box>

      <Box component="footer" py={2} textAlign="center">
        <Typography variant="caption">
          © {new Date().getFullYear()} My Company.{' '}
          <Link href="/privacy" target="_blank">Privacy</Link> |{' '}
          <Link href="/tos" target="_blank">Terms of Service</Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default function App() {
  const { isSignedIn } = useAuth();
  return isSignedIn ? <SignedInLayout/> : <SignedOutSplash/>;
}